import React from "react";
import Modal from "react-responsive-modal";
import { Button } from "../../../revvComponents";

const EsignAcceptRejectPopup = ({
  cancelPopup,
  approveRejectDoc,
  emailMessage,
  changeReviewMessage,
  reviewerEmailMessage,
}) => {
  const rejectDoc = () => (
    <Modal
      classNames={{
        modal: "recipientdocinfopopup-modal recipient-accept-reject-modal",
        closeButton: "remove-modal-popup-close",
      }}
      open
      onClose={cancelPopup}
      center
      styles={{
        overlay: {
          background: "rgba(0, 0, 0, 0.60)",
        },
      }}
      closeOnOverlayClick>
      <div className="recipientdocinfopopup-container">
        {/* ------ Recipient document info header(gif, recipient title and send info) section ------ */}
        <div className="recipientdocinfopopup-header recipient-white-bg">
          <div className="recipientdocinfopopup-recipient-title">
            Decline this document?
          </div>
          <div className="recipientdocinfopopup-sender-info unfilled-info esign-reject-info">
            If you want, add a note for the sender about why you&apos;re
            declining it.
          </div>
        </div>

        {/* ------ Recipient document footer info section  ------ */}
        <div className="recipientdocinfopopup-footer-info recipient-footer-info esign-reject-document-footer-info">
          <textarea
            cols="55"
            rows="8"
            placeholder="Add your note"
            value={`${emailMessage || reviewerEmailMessage}`}
            onChange={e => changeReviewMessage(e)}
            data-test="docsharing-reviewer-email-acceptor"
          />
        </div>

        <div className="esign-reject-document-popup-footer">
          <Button
            data-test="back-to-document-button"
            className="esign-reject-document-cancel"
            onClick={cancelPopup}
            onKeyPress={() => {}}>
            Cancel
          </Button>
          <Button
            data-test="submit-anyway-button"
            className="esign-reject-document"
            onClick={approveRejectDoc}
            onKeyPress={() => {}}>
            Decline
          </Button>
        </div>
      </div>
    </Modal>
  );

  const getPopup = () => rejectDoc();

  return getPopup();
};
export default EsignAcceptRejectPopup;
